import { Validator } from './Validator';
import { ValidationError } from './ValidatorError';
export class SendRawMessageActionSettingsValidator extends Validator {
    validate(model) {
        if (!model.type) {
            throw new ValidationError('The raw message content type is required');
        }
        if (!model.type.match(/^([{{^\w+(\.\@\w+)*$]+}})|([-\w]+\/[-\w.]+(\+\w+)?$)/)) {
            throw new ValidationError('The raw message content type is invalid');
        }
        if (!model.rawContent) {
            throw new ValidationError('The raw message content is required');
        }
    }
}
